import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Grid } from "@mui/material";

import Fetching from "../../../Common/Fetching";
import TermCard from "./TermCard";
import { DataTypes } from "../../../../constants";
import rmsActions from "../../../../actions/rmsActions";
import { getTerms, getRmsAppCode, isFetching } from "../../../../reducers";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import TermFormDialog from "./TermFormDialog";


function TermList() {
    const dispatch = useDispatch();
    const appCode = useSelector(getRmsAppCode);
    const isFetchingTerms = useSelector((state) => isFetching(state, DataTypes.TERMS));
    const terms = useSelector(getTerms);
    const [openDialog, setOpenDialog] = useState(null);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        if (!!appCode) {
            dispatch(rmsActions.getTerms(appCode));
        }
    }, [dispatch, appCode]);

    const handleCloseDialog = () => {
        setSelected(null);
        setOpenDialog(null);
    };

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isFetchingTerms && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {!!terms &&
                    terms
                        .sort((a, b) => a.uuid - b.uuid)
                        .map((term) => (
                            <Grid item xs={12} key={term.uuid} className="card-grid-item" >
                                <TermCard
                                    term={term}
                                    onClick={() => {
                                        setSelected(term);
                                        setOpenDialog("submit");
                                    }}
                                />
                            </Grid>
                        ))
                }
            </Grid>

            {openDialog === "submit" && (
                <TermFormDialog
                    open={true}
                    onSubmit={(params) => dispatch(rmsActions.updateTerm(selected.uuid, {form: params}, appCode, () => dispatch(rmsActions.getTerms(appCode))))}
                    onClose={handleCloseDialog}
                    scroll="paper"
                    term={selected}
                />
            )}
        </Container>
    );
}

export default TermList;
